import {HttpHeaders} from '@angular/common/http';
import {
  AddSkillResponse,
  Configuration,
  EditGroupMembershipResponse,
  EditSkillResponse,
  GetAgentModeResponse,
  GetAgentStateResponse,
  GetSkillsResponse,
  GetUnavailableReasonsResponse,
  GroupMembership,
  LoginAgentResponse,
  LogoutAgentResponse,
  QueueControlServiceInterface,
  RemoveSkillResponse,
  Response,
  SetAgentModeResponse,
  SetAgentStateResponse,
  Skill,
  UnavailableReason
} from '@gt-api';
import {MockData} from '@testhelper/mock-data';
import {Observable, of} from 'rxjs';

export class QueueControlServiceStub implements QueueControlServiceInterface {
  defaultHeaders: HttpHeaders = new HttpHeaders();
  configuration: Configuration;

  addSkill1(organization?: string, login?: string, body?: Skill): Observable<AddSkillResponse> {
    return of({code: 200});
  }

  editGroupMembership1(organization?: string, login?: string, body?: GroupMembership): Observable<EditGroupMembershipResponse> {
    return of({code: 200});
  }

  editSkill1(organization?: string, login?: string, body?: Skill): Observable<EditSkillResponse> {
    return of({code: 200});
  }

  editUnavailableReason1(organization?: string, login?: string, body?: UnavailableReason): Observable<Response> {
    return of({code: 200});
  }

  getAgentMode1(organization?: string, login?: string): Observable<GetAgentModeResponse> {
    return of({code: 200, agentMode: 0});
  }

  getAgentState1(organization?: string, login?: string): Observable<GetAgentStateResponse> {
    return of({code: 200, agentState: {status: 0, subStatus: 0, pendingStatus: 1}});
  }

  getSkills1(organization?: string, login?: string): Observable<GetSkillsResponse> {
    return of({code: 200, skills: MockData.getSkillsData()});
  }

  getUnavailableReasons1(organization?: string, login?: string): Observable<GetUnavailableReasonsResponse> {
    return of({code: 200});
  }

  loginAgent1(organization?: string, login?: string): Observable<LoginAgentResponse> {
    // const ast = PushEventsMock.getAgentStateTransition();
    // ast.agent_login = login;
    // ast.oname = organization;
    // ast.new_state = 1;
    // this.pushEventService.pushSubjects.AgentStateTransition.next(ast);
    return of({code: 200});
  }

  logoutAgent1(organization?: string, login?: string): Observable<LogoutAgentResponse> {
    // const ast = PushEventsMock.getAgentStateTransition();
    // ast.agent_login = login;
    // ast.oname = organization;
    // ast.new_state = 0;
    // this.pushEventService.pushSubjects.AgentStateTransition.next(ast);
    return of({code: 200});
  }

  removeSkill1(organization?: string, login?: string, body?: Skill): Observable<RemoveSkillResponse> {
    return of({code: 200});
  }

  removeUnavailableReasonWithId1(id: number, organization?: string, login?: string, extraHttpRequestParams?: any): Observable<Response> {
    return of({code: 200});
  }

  removeUnavailableReason1(organization?: string, login?: string, body?: UnavailableReason): Observable<Response> {
    return of({code: 200});
  }

  setAgentMode1(newMode: number, organization?: string, login?: string): Observable<SetAgentModeResponse> {
    return of({code: 200});
  }

  setAgentState1(
    state: number,
    organization?: string,
    login?: string,
    subState?: number,
    pendingState?: number
  ): Observable<SetAgentStateResponse> {
    return of({code: 200});
  }
}
